module.exports = __webpack_public_path__ + "static/media/poo.0d95fd61.svg";